import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import quienesSomos0 from './images//quienes-somos-0.jpg'
import quienesSomos1 from './images//quienes-somos-1.jpg'
import quienesSomos2 from './images//quienes-somos-2.jpg'


const QuienesSomos = class QuienesSomos extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            try {
                window.jQuery('.flexslider').flexslider({
                    directionNav: false,
                    slideshowSpeed: 4000
                })
                window.jQuery('[data-toggle="tooltip"]').tooltip()
            } catch(e) {}
        }, 500);
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Quienes somos</title>
                </Helmet>

                <div className="about-us-slider">
                    <div className="container">
                        <div className="header">
                            <h3>Quienes somos</h3>
                        </div>
                        <p>
                            Dismocan es una pequeña empresa ubicada en El Sauzal, Tenerife. Nos especializamos en soluciones técnicas de los procesos tanto constructivos como de mantenimiento de edificaciones.
                        </p>
                        <p>
                            Gracias al buen trabajo y el afán de siempre aportar el mejor conocimiento, contamos con el respaldo de grandes marcas en nuestro catálogo de productos.
                        </p>
                        <div className="flexslider">
                            <ul className="slides">
                                <li>
                                    <img src={quienesSomos0} alt="office2" />
                                </li>
                                <li>
                                    <img src={quienesSomos1} alt="office1" />
                                </li>
                                <li>
                                    <img src={quienesSomos2} alt="office3" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {
                    /*
                    <div className="about-us-team">
                        <div className="container">
                            <h1 className="header">Pellentesque luctus felis nec ante facilis</h1>
                            <div className="row">
                                <div className="col-md-6">
                                    <p>
                                        Mauris in est posuere orci suscipit dignissim. Integer vel diam quis lectus rhoncus laoreet. Donec sollicitudin vehicula dolor, quis suscipit eros commodo at.
                                    </p>
                                    <p>
                                        Sed cursus varius mauris, at volutpat ex mattis vel. Praesent et turpis nec nunc euismod sagittis a et lectus. Suspendisse eget leo sagittis, sagittis tortor vitae, elementum sapien. Aliquam pulvinar auctor nulla.
                                    </p>
                                </div>
                                <div className="col-md-6">
                                    <p>
                                        Cras varius, mauris id feugiat faucibus, lorem ipsum pharetra elit, in vehicula ipsum nunc rutrum urna. Quisque tempus purus eu enim consequat tristique. Sed orci tellus, dignissim at velit tincidun.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    */
                }

                <div className="signup-cta">
                    <div className="container">
                        <div className="wrapper clearfix">
                            <h4>No dudes en contactar con nosotros</h4>
                            <Link to="/contacto" className="btn-shadow btn-shadow-info btn-shadow-lg mt-4">Contacto</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
        
export default QuienesSomos



// WEBPACK FOOTER //
// ./src/pages/quienes-somos/index.js